import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useDeleteOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const deleteRequest = (
    guid,
    getEntryOperationList,
    setIsDeleteModalOpen,
    setDeleteLoading,
  ) => {
    axiosClient
      .delete(`Operation/Delete?GUID=${guid}`)
      .then(res => {
        if (res.status === 200) {
          getEntryOperationList?.();
          setIsDeleteModalOpen?.(false);
          enqueueSnackbar(`حذف با موفقیت انجام شد`, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setDeleteLoading?.(false));
  };

  return { deleteRequest };
};

export default useDeleteOperation;
